import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ShadeToolsService} from '../../../core/services/shade-tools.service';
import {DialogBoxOption} from '../../../shared/models/dialog-box';
import {RouterLink} from '@angular/router';
import {SpinnerComponent} from '../spinner/spinner.component';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'motn-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    SpinnerComponent,
    FormsModule,
  ],
})
export class DialogBoxComponent implements OnInit, AfterViewInit {
  @Input() header: string = 'Modals in Motion';
  @Input() message: string = '';
  @Input() messageHtml: string = '';
  @Input() options: DialogBoxOption[] = [];
  @Input() enableInput: boolean = false;
  @Input() passwordInput: boolean = false;
  @Input() closeOnButtonClick: boolean = true;

  buttonSpinners: boolean[] = [];

  public userInput: string = '';

  @ViewChild('dialogBoxInput') private inputEl: ElementRef<HTMLInputElement>;


  constructor(
    private shadeToolsService: ShadeToolsService,
  ) {
  }


  ngOnInit(): void {
    for (let option in this.options) {
      this.buttonSpinners.push(false);
    }
  }


  ngAfterViewInit() {
    this.inputEl?.nativeElement.focus();
  }


  pressedEnter(): void {
    const defaultOptionIndex: number = this.options.findIndex(o => o.callbackIsDefault);

    if (defaultOptionIndex > -1) {
      const defaultOption: DialogBoxOption = this.options[defaultOptionIndex];
      this.execute(defaultOption.callback, defaultOptionIndex);
    }
  }


  /**
   *
   * @param func {(input?: string) => void} The optional input arg only works
   *    if this.enableInput is set to true
   * @param optionIndex {number}
   */
  execute(func: (input?: string) => void, optionIndex: number): void {
    this.buttonSpinners[optionIndex] = true;

    if (this.closeOnButtonClick) {
      this.shadeToolsService.closeAll();
    }

    setTimeout(() => { // timeout needed to get spinner moving
      func(this.userInput);
    }, 0);
  }
}
